import { Button } from '../../../components/Button/Button';
import { BreakGlassIcon } from '../../../icons/BreakGlass';
import { DownloadIcon } from '../../../icons/Download';
import './Login.scss';
import '../../../shared/styles/Common.scss';
import { useAuth0 } from '@auth0/auth0-react';

export interface LoginProps {
  onBreakGlassClick: () => void;
}

export function Login({ onBreakGlassClick }: LoginProps) {
  const { loginWithRedirect } = useAuth0();

  const handleBreakGlassClick = () => {
    onBreakGlassClick();
  };

  return (
    <div className="login-container">
      <div className="title">Welcome!</div>
      <div className="sub-header">Please log in to continue.</div>
      <div className="controls">
        <Button className="login-button primary" label="login" onClick={loginWithRedirect} icon={<DownloadIcon />} iconPlacement="left" />
        <Button className="break-glass-button secondary" icon={<BreakGlassIcon />} onClick={handleBreakGlassClick} />
      </div>
    </div>
  );
}
